import React, { useEffect, useState } from "react";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import parse from "html-react-parser";
import Pagination from "../../../../Reusable/Pagination/Pagination.js";
import { LinkToNewTab } from "../../../../Elements/Link/Link.js";
import { convertNumToMoney } from "../Utils/ExternalFunctions.js";
import "../JumboPay.scss";
import JumboPayTableContainer from "../Utils/JumboPayTable/JumboPayTableContainer.js";

const ReceivedPayments = ({ userData }) => {
  const { getTextByKey, getLanguageCulture, getDirection } = useContent();
  const [allData, setAllData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPages, setMaxPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [emptyTransactions, setEmptyTransactions] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const headerTable = [
    {
      enName: "Date",
      constName: "statement-table-date",
      className: "header-date",
    },
    {
      enName: "Status",
      constName: "payment-status",
      className: "header-status",
    },
    {
      enName: "Action",
      constName: "received-from-text-jumbopay",
      className: "header-action",
    },
    {
      enName: "Gross",
      constName: "gross-text-jumbopay",
      className: "header-gross",
    },
    {
      enName: "Fee",
      constName: "fee-text-jumbopay",
      className: "header-fee",
    },
    {
      enName: "Net",
      constName: "net-text-jumbopay",
      className: "header-net",
    },
    {
      enName: "Referrer mail",
      constName: "payment-referrar-mail",
      className: "header-referrer-mail",
    },
  ];

  const getAllActions = async (currentPageNum) => {
    setLoading(true);
    const parameters = {
      culture: getLanguageCulture(),
      top: 10,
      from: currentPageNum * 10 - 10,
    };
    const response = await apiRequest(
      "Transactions",
      "ReactGetAllJumbopayTransactionsAsSellerPagination",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        setTotalSum(response.data.totalSum);
        setMaxPages(response.data.TransactionsCount);
        setAllData(response.data.JumbopayTransactionsAsSeller);
        if (response.data.TransactionsCount === 0) {
          setEmptyTransactions(true);
        } else {
          setEmptyTransactions(false);
        }
      }
    }
    setLoading(false);
  };

  //upper the num of pages
  function up(v, n) {
    return Math.ceil(v * Math.pow(10, n)) / Math.pow(10, n);
  }

  const fixRequestDate = (requestDate) => {
    let temp = requestDate;
    if (requestDate.includes("#Payment_transaction_id#")) {
      temp = requestDate.replace(
        "#Payment_transaction_id#",
        getTextByKey("payment-transaction-id")
      );
    }
    return temp;
  };
  const fixStatusDisplay = (status) => {
    let temp = status;
    if (status.includes("#Payment_status_complete#")) {
      temp = status.replace(
        "#Payment_status_complete#",
        getTextByKey("payment-status-complete")
      );
    } else if (status.includes("#Payment_status_canceled#")) {
      temp = status.replace(
        "#Payment_status_canceled#",
        getTextByKey("payment-status-canceled")
      );
    } else if (status.includes("#Payment_status_pending#")) {
      temp = status.replace(
        "#Payment_status_pending#",
        getTextByKey("payment-status-pending")
      );
    } else if (status.includes("#Payment_withdrawal_request_status#")) {
      temp = status.replace(
        "#Payment_withdrawal_request_status#",
        getTextByKey("payment-request-withdrawal")
      );
    }
    return temp;
  };
  const fixActionDisplay = (action) => {
    let temp = action;
    if (action.includes("#Payment_sent_to#")) {
      temp = action.replace(
        "#Payment_sent_to#",
        getTextByKey("payment-sent-to")
      );
    } else if (action.includes("#Payment_recived_from#")) {
      temp = action.replace(
        "#Payment_recived_from#",
        getTextByKey("payment-receive-from")
      );
    } else if (action.includes("#Payment_Status_Requested#")) {
      temp = action.replace(
        "#Payment_Status_Requested#",
        getTextByKey("payment-status-request")
      );
    }
    return temp;
  };

  const fixRefferalMail = (refferalMail) => {
    let temp = refferalMail;
    // if (refferalMail.includes("#DownloadURL#")) {
    //   temp = refferalMail.replace("#DownloadURL#", "#check#");
    // }
    if (refferalMail.includes("#Payment_Recevied_Mail_alt#")) {
      temp = refferalMail.replace(
        "#Payment_Recevied_Mail_alt#",
        getTextByKey("payment-received-mail-alt")
      );
    }
    return temp;
  };

  const renderFee = (item) => {
    const fee = item?.transaction_jumbopay_settings?.FixedFee;
    const invoiceUrl = item?.transaction_fee?.transaction_invoiceUrl;

    return (
      <>
        <span>
          {convertNumToMoney({ num: fee })}
        </span>
        <span style={{ marginLeft: '8px' }}>
          <LinkToNewTab
            className="fee_invoice"
            page={invoiceUrl}
            rel="noopener noreferrer"
            isNewTab={true}
            fullUrl={true}
          >
            <i className="fas fa-external-link-alt"></i>
          </LinkToNewTab>
        </span>
      </>
    );
  }

  useEffect(() => {
    getAllActions(currentPage);
  }, [currentPage]);

  const bodyTable = [
    {
      fieldClass: `item-request-date ${
        getDirection() === "rtl" ? "request-date-rtl" : ""
      }`,
      fieldName: "RequestDateConverted",
      render: (item) =>
        parse(fixRequestDate(item.transaction_dateTime_converted)),
    },
    {
      fieldClass: `item-status`,
      fieldName: "Status",
      render: (item) => parse(fixStatusDisplay(item.transaction_status_icon)),
    },
    {
      fieldClass: `item-action`,
      fieldName: "Action",
      render: (item) =>
        parse(fixActionDisplay(item.transaction_jumbopay_settings.BuyerName)),
    },
    {
      fieldClass: `item-gross`,
      fieldName: "gross",
      render: (item) => convertNumToMoney({ num: item.transaction_totalPrice }),
    },
    {
      fieldClass: `item-fee`,
      fieldName: "Fee",
      render: (item) => renderFee(item),
    },
    {
      fieldClass: `item-net`,
      fieldName: "NetPrice",
      render: (item) =>
        convertNumToMoney({
          num: item.transaction_jumbopay_settings.NetPrice,
        }),
    },
    {
      fieldClass: `item-referral-mail`,
      fieldName: "Referral_Mail",
      render: (item) =>
        parse(
          fixRefferalMail(item.transaction_jumbopay_settings.MailEncryptedId)
        ),
    },
  ];

  const mobileRowTable = (item, i) => {
    return (
      <div key={i} className="row-item-table">
        <div className="item-request-date">
          {parse(item.transaction_dateTime_converted)}
          <span className="status">
            {parse(fixStatusDisplay(item.transaction_status_icon))}
          </span>
        </div>
        <div className="item-action mobile-style">
          {parse(
            fixActionDisplay(item.transaction_jumbopay_settings.BuyerName)
          )}
        </div>
        <div className="item-gross mobile-style">
          <span className="type">{getTextByKey("gross-text-jumbopay")}</span>
          {convertNumToMoney({
            num: item.transaction_totalPrice,
          })}
        </div>
        <div className="item-amount mobile-style">
          <span className="type">{getTextByKey("net-text-jumbopay")}</span>
          {convertNumToMoney({
            num: item.transaction_jumbopay_settings.NetPrice,
          })}
        </div>
        <div className="item-fee mobile-style">
          <span className="type">{getTextByKey("fee-text-jumbopay")}</span>
          {convertNumToMoney({
            num: item.transaction_jumbopay_settings.FixedFee,
          })}
          <LinkToNewTab
            className="fee_invoice"
            page={`${item.FeeInvoice}`}
            rel="noopener noreferrer"
            isNewTab={true}
          >
            <i className="fas fa-external-link-alt"></i>
          </LinkToNewTab>
        </div>
        <div className="item-referral-mail mobile-style">
          <span className="type">{getTextByKey("payment-referrar-mail")}</span>
          <LinkToNewTab
            className="mail_referal"
            page={`gallery/${item.mailEncryptedId}`}
            rel="noopener noreferrer"
            isNewTab={true}
          >
            <i className="fas fa-external-link-alt"></i>
          </LinkToNewTab>
        </div>
      </div>
    );
  };

  return (
    <div className="account-status-container">
      <div className="header">
        <div className="left-side">
          <div className="title">
            <h1>{getTextByKey("profile-menu-jumbopay-received-payments")}</h1>
            <span className="sub-title">
              {getTextByKey("received-payments-subtitle")}
            </span>
            <p className="sub-title">
              {getTextByKey("total-revenues")}{" "}
              {convertNumToMoney({ num: totalSum })}
            </p>
          </div>
        </div>
      </div>
      <div className="data-table">
        <JumboPayTableContainer
          tableSecture={bodyTable}
          headerTable={headerTable}
          data={allData}
          mobileRowRender={mobileRowTable}
          loading={loading}
          emptyTransactions={emptyTransactions}
          emptyTransactionsText="payment-no-money-recived"
        />
        {!emptyTransactions && !loading && maxPages > 10 && (
          <Pagination
            currentPage={currentPage}
            maxPages={maxPages > 0 ? up(maxPages / 10, 0) : 1}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>
    </div>
  );
};

export default ReceivedPayments;
